export default __webpack_public_path__ + "static/media/lock.6f2e5043.svg";